import {
  Agreement,
  Typenames,
  V2ATransferDetailsResult,
  V2ATransferUtilizationMessageResult,
} from '@varo/graphql-schema-types';
import {
  AllRecipientAndLocalRecipient,
  EXTERNAL_USER,
} from 'features/v2a/sender/helpers/Sender.helpers';
import { useEffect, useState } from 'react';
import V2ATransferDetails from 'services/graphql/queries/MoveMoney/V2ATransferDetails';
import V2ATransferUtilizationMessage from 'services/graphql/queries/MoveMoney/V2aTransferUtilizationMessage';
import { useQuery } from 'urql';

const useV2ATransferDetails = (
  transferAmount: string | undefined,
  recipient?: AllRecipientAndLocalRecipient,
) => {
  const [confirmationMessage, setConfirmationMessage] = useState<string | null>(
    null,
  );
  const input = recipient?.id !== EXTERNAL_USER ? recipient?.id : null;

  const [maxLimit, setMaxLimit] = useState<string | null>(null);
  const [transferAgreement, setTransferAgreement] = useState<Agreement | null>(
    null,
  );
  const [isSubmitButtonDisable, setIsSubmitButtonDisable] = useState(true);

  const [transferLimitTitle, setTransferLimitTitle] = useState<string>('');
  const [transferLimitMessage, setTransferLimitMessage] = useState<string>('');

  const [pauseTransferLimit, setPauseTransferLimit] = useState(true);
  const [{ data, fetching }] = useQuery<{
    v2aTransferDetails: V2ATransferDetailsResult;
  }>({
    query: V2ATransferDetails,
    requestPolicy: 'network-only',
    variables: {
      input: { recipientID: input },
    },
  });

  const [{ data: transferLimitData, fetching: transferLimitFetching }] =
    useQuery<{
      v2aTransferUtilizationMessage: V2ATransferUtilizationMessageResult;
    }>({
      query: V2ATransferUtilizationMessage,
      requestPolicy: 'network-only',
      pause: pauseTransferLimit,
      variables: {
        input: { recipientId: input },
      },
    });

  useEffect(() => {
    if (transferLimitData) {
      if (
        transferLimitData.v2aTransferUtilizationMessage.__typename ===
        Typenames.V2ATransferUtilizationMessageSuccess
      ) {
        setTransferLimitTitle(
          transferLimitData.v2aTransferUtilizationMessage.successTitle,
        );
        setTransferLimitMessage(
          transferLimitData.v2aTransferUtilizationMessage.successMessage,
        );
      }
    }
  }, [transferLimitData]);

  const fetchTransferLimit = () => {
    setPauseTransferLimit(false);
  };
  useEffect(() => {
    if (data) {
      if (
        data.v2aTransferDetails.__typename ===
        Typenames.V2ATransferDetailsResultSuccess
      ) {
        setConfirmationMessage(
          data.v2aTransferDetails.confirmationMessage as string,
        );
        setMaxLimit(data.v2aTransferDetails.maxTransfer.formatted);
        setTransferAgreement(
          (data.v2aTransferDetails.agreement as Agreement) ?? null,
        );
        setIsSubmitButtonDisable(
          !(
            parseFloat(transferAmount ?? '0.00') >= 1.0 &&
            parseFloat(transferAmount ?? '0.00') <=
              parseFloat(data.v2aTransferDetails.maxTransfer.amount.toString())
          ),
        );
      }
    }
  }, [data, transferAmount]);

  return {
    confirmationMessage,
    maxLimit,
    transferAgreement,
    isSubmitButtonDisable,
    fetching,
    transferLimitTitle,
    transferLimitMessage,
    transferLimitFetching,
    fetchTransferLimit,
  };
};

export default useV2ATransferDetails;
